import type { FactoidType } from "@constructor/shared-entity/type";
import FCApp from "./FCApp/FCApp.vue";
import FCBonus from "./FCBonus/FCBonus.vue";
import FCBuilder from "./FCBuilder/FCBuilder.vue";
import FCDarkstore from "./FCDarkstore/FCDarkstore.vue";
import FCDelivery from "./FCDelivery/FCDelivery.vue";
import FCDeliveryDiscount from "./FCDeliveryDiscount/FCDeliveryDiscount.vue";
import FCInstallment from "./FCInstallment/FCInstallment.vue";
import FCSale from "./FCSale.vue";
import FCMerch from "./FCMerch/FCMerch.vue";
import FCPromo from "./FCPromo/FCPromo.vue";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const components: { [key in FactoidType]: any } = {
  FCDelivery,
  FCDeliveryDiscount,
  FCApp,
  FCBonus,
  FCBuilder,
  FCDarkstore,
  FCInstallment,
  FCSale,
  FCMerch,
  FCPromo,
};

export default components;
